module.exports = __webpack_public_path__ + "static/img/company.e78ac6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.png
// module id = NeCJ
// module chunks = 0